/*
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-06-29 13:45:42
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-07-08 16:07:34
 */
import Vue from 'vue'
import Vuex from 'vuex'
import api from '../api'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    activeTab: 0,
    userInfo: {},
    selectCircle: [],
    selectLabel: [],
    avatarList: [],
    nameList: [],
    userInfoList: [],
    bbsSubInfo: {},
    authorityTopicList: [],
    hotTopicList: [],
  },
  mutations: {
    updateTab(state, payload) {
      state.activeTab = payload
    },
    updateUserInfo(state, payload) {
      state.userInfo = payload
    },
    updateBbsSubInfo(state, payload) {
      state.bbsSubInfo = payload
    },
    updateSelectCircle(state, payload) {
      state.selectCircle = payload
    },
    updateSelectLabel(state, payload) {
      state.selectLabel = payload
    },
    updateAuthorityTopicList(state, payload) {
      state.authorityTopicList = payload;
    },
    updateHotTopicList(state, payload) {
      state.hotTopicList = payload;
    },
    updateAvatarList(state, payload) {
      state.avatarList = payload
    },
    updateNameList(state, payload) {
      state.nameList = payload
    },
    updateUserInfoList(state, payload) {
      const oldUserInfoList = state.userInfoList?.slice(0);
      const filterUsers = oldUserInfoList?.filter((user) => !(payload?.find((item) => item.userId === user.userId)));
      state.userInfoList = [...filterUsers, ...payload]
    },
  },
  actions: {
    updateTab({ commit }, payload) {
      commit('updateTab', payload)
    },
    updateUserInfo({ commit }) {
      api.getUserInfo().then(res => {
        if (res.code === 200) {
          commit('updateUserInfo', res.data)
        }
      })
    },
    updateBbsSubInfo({ commit }, payload) {
      commit('updateBbsSubInfo', payload)
    },
    updateAvatarList({ commit }) {
      api.getAnonymousAvatar().then(res => {
        const { code, data } = res
        if (code === 200) {
          commit('updateAvatarList',data)
        }
      })
    },
    updateAuthorityTopicList({ commit }) {
      api.fetchAuthorityTopicList().then(res => {
        const { code, data } = res
        if (code === 200) {
          commit('updateAuthorityTopicList',data?.map((item) => ({
            ...item, authority: 1
          })) || []);
        }
      })
    },
    updateHotTopicList({ commit }) {
      api.searchTopic().then(res => {
        const { code, data } = res
        if (code === 200) {
          commit('updateHotTopicList',data || []);
        }
      })
    },
    updateNameList({ commit }) {
      api.getAnonymousName().then(res => {
        const { code, data } = res
        if (code === 200) {
          commit('updateNameList',data)
        }
      })
    },
    updateUserInfoList({ commit }, payload) {
      api.getUserFansNumber(payload).then(res => {
        const { code, data } = res;
        if (code === 200 && data) {
          commit('updateUserInfoList', data)
        }
      })
    }
  }
})

export default store